import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.667 1.333c.368 0 .667.272.667.606v.606h1.333c1.104 0 2 .814 2 1.819v8.485c0 1.004-.896 1.818-2 1.818H3.333c-1.104 0-2-.814-2-1.819V4.365c0-1.005.896-1.819 2-1.819h1.334V1.94c0-.334.298-.606.667-.606.368 0 .666.272.666.606v.606h4V1.94c0-.334.299-.606.667-.606m-6 2.425v.606c0 .334.298.606.667.606.368 0 .666-.272.666-.606v-.606h4v.606c0 .334.299.606.667.606s.667-.272.667-.606v-.606h1.333c.368 0 .667.27.667.606v1.818H2.667V4.364c0-.335.298-.606.666-.606zm8.667 3.636v5.454c0 .335-.299.607-.667.607H3.333c-.368 0-.666-.272-.666-.607V7.395z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M5.137 9.683a.665.665 0 1 1-.941-.941.665.665 0 0 1 .94.94"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })